module.exports = __webpack_public_path__ + "img/french_chillers.e94ba9c1.jpeg";